import {constructThirdPartyDetails, constructThirdPartyList} from "../Factory/factory";
import {fetchThirdPartyList, fetchThirdPartyDetails} from "../Util/queries";
import { THIRD_PARTY_BILLING_LIST } from "../Reducers/thirdPartyListReducer";
import { THIRD_PARTY_BILLING_DETAILS } from "../Reducers/thirdPartyDetailsReducer";

export const getThirdPartyList = () =>
    async (dispatch) => {
        try {
            let response = await fetchThirdPartyList();
            if (response.data) {
                let partnerBillingDetailsObj = constructThirdPartyList(response.data);
                dispatch({
                    type: THIRD_PARTY_BILLING_LIST,
                    payload: partnerBillingDetailsObj
                })
            } else {
                dispatch({
                    type: THIRD_PARTY_BILLING_LIST,
                    payload: null
                })
            }
        } catch (e) {
            console.error(e)
            dispatch({
                type: THIRD_PARTY_BILLING_LIST,
                payload: null
            })
        }
    }

export const getThirdPartyDetails = (date) =>
    async (dispatch) => {
        try {
            let response = await fetchThirdPartyDetails(date);
            if (response.data) {
                let partnerBillingDetailsObj = constructThirdPartyDetails(response.data);
                dispatch({
                    type: THIRD_PARTY_BILLING_DETAILS,
                    payload: partnerBillingDetailsObj
                })
                return partnerBillingDetailsObj;
            } else {
                dispatch({
                    type: THIRD_PARTY_BILLING_DETAILS,
                    payload: null
                })
                return null;
            }
        } catch (e) {
            console.error(e)
            dispatch({
                type: THIRD_PARTY_BILLING_DETAILS,
                payload: null
            })
            return null;
        }
    }

export {THIRD_PARTY_BILLING_LIST, THIRD_PARTY_BILLING_DETAILS};
